import format from "../../../shared/format"
export const { name, initials, plural } = format
